export enum BaseRoutesPath {
  LOGIN = '/login',
  HOME = '/',
  PROFILE = '/profile',
  HELP = '/help',
  TESTS = '/testo',
}
